<template lang="pug">
shListData(title="Tallas" resolver="sizes" keyData="size" component="shSize")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Sizes',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/size/Sizes.vue